import moment from "moment-timezone";

export default {
  computed: {},
  methods: {
    getReservationEndTime(hours, start) {
      const startTime = moment(start, 'HH:mm');

      const addedTime = startTime.add(parseFloat(hours), 'hours');

      return addedTime.format('HH:mm');
    },
    getReservationStartTime(systemCodeStartTime) {
      return moment(systemCodeStartTime, 'hh:mm').format('HH:mm')
    },
  }
};
